module.exports = __webpack_public_path__ + "static/logo-5b9a9479781bc889c5d9a235dbc16211.jpg";